module.exports = __webpack_public_path__ + "static/media/close.052c88cd.svg";